import React  from 'react';
import { useDispatch } from 'react-redux';
import {
    toggleShowModal,
} from '../Actions/QuickSearch.action';
import magnifier from '../../images/magnifier.svg';
import {translate} from "../Services/translation";


const QuickSearchButton = () => {
    const dispatch = useDispatch();
    
    return (
        <button className="quick-search__button"  
                onClick={() => dispatch(toggleShowModal())}
                aria-label={translate('quicksearch.button')}
                aria-controls="quick-search-modal-container"
                aria-haspopup="dialog"
        >
            <img className="quick-search__button-icon" src={magnifier} alt=""/>
        </button>
    );
};

export default QuickSearchButton;
